export const borderStyle = ['none', 'solid'];
